import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import s from './styles.module.css'
import { renderContentItems } from 'utilities/contentful'

export interface BaseQuestionProps {
  question: {
    id: number
    text: string
    isRequired?: boolean
    type: string
    hideText?: boolean
  }
  // React Hook Form mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  error?: string
  children: React.ReactNode
}

const BaseQuestion: React.FC<BaseQuestionProps> = ({
  question,
  control,
  errors,
  error: zustandError,
  children,
}) => {
  // Get error message from either RHF or Zustand
  const getErrorMessage = (): string | null => {
    // Zustand mode
    if (zustandError) return zustandError

    // RHF mode
    if (control && errors) {
      const error = errors[`question_${question.id}`]
      if (!error) return null
      if (typeof error === 'string') return error
      if (error && typeof error === 'object' && 'message' in error) {
        return error.message as string
      }
    }

    return null
  }

  const questionError = getErrorMessage()

  return (
    <div className={s.question}>
      {question.hideText !== true && (
        <label className={s.questionText}>
          {question.text}
          {question.isRequired && <span className={s.required}> *</span>}
          {question.type !== 'freeFormSkip' &&
            question.richTextNote &&
            question.richTextNote.content && (
              <div className={s.supportingText}>
                {renderContentItems(question.richTextNote.content)}
              </div>
            )}
        </label>
      )}
      {children}
      {questionError && <div className={s.error}>{questionError}</div>}
    </div>
  )
}

export default BaseQuestion
